import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent {
  @Input() subTitle = '';
  @Input() title = '';

  @Input() showLogo = false;
}
